module.exports = __webpack_public_path__ + "img/bvc.d2966040.png";